import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import Deposito from "model/suprimentos/Deposito";
import CondicaoPagamento from "model/fiscal/CondicaoPagamento";
import FormaPagamento from "model/fiscal/FormaPagamento";
import PessoaEndereco from "model/fiscal/PessoaEndereco";
import Representante from "model/fiscal/Representante";
import SerieNotaFiscal from "model/fiscal/SerieNotaFiscal";
import TransacaoNotaFiscal from "model/fiscal/TransacaoNotaFiscal";

import ItemPedido from "model/producao/ItemPedido";

export interface ItemEmissaoNotaFiscalSaida {
    transacaoNotaFiscal?: TransacaoNotaFiscal | null;
    camposInformados?: string[] | null;
    tributaIcms?: boolean | null;
    tributaIpi?: boolean | null;
    tributaPis?: boolean | null;
    tributaCofins?: boolean | null;
    tributaIbs?: boolean | null;
    tributaCbs?: boolean | null;

    itemPedido?: ItemPedido | null;
    produto: Produto | null;
    deposito: Deposito | null;
    lote: string | null;
    descricaoProduto: string;
    codigoProdutoFiscal: string;
    unidadeComercial: string;
    quantidadeComercial: number;
    unidadeTributavel?: string | null;
    quantidadeTributavel?: number | null;
    aliquotaIcms?: number | null;
    aliquotaIpi?: number | null;
    percentualReducaoBaseIpi?: number | null;
    percentualReducaoBaseIcms?: number | null;
    percentualDiferimentoIcms?: number | null;
    informarCalculoIcms51?: boolean | null;
    aliquotaPis?: number | null;
    aliquotaCofins?: number | null;
    aliquotaIcmsUfDestino?: number | null;
    aliquotaFcpUfDestino?: number | null;
    aliquotaInterestadual?: number | null;
    beneficioFiscal?: string | null;
    valorUnitario: number;
    ncm: string;
    cest: string | null;
    cfop: string;
    cstIcms: string | null;
    csosn: string | null;
    cstPis: string | null;
    cstIpi?: string | null;
    codigoEnquadramentoIpi?: string | null;
    cstCofins: string | null;
    cstIbsCbs: string | null;
    modalidadeTributacaoIbsCbs?: "PERCENTUAL" | "NAO_TRIBUTADO" | null;
    classificacaoTributaria: string | null;
    aliquotaIbsEstadual: number | null;
    aliquotaIbsMunicipal: number | null;
    aliquotaCbs: number | null;
    valorDesconto: number;
    valorFrete: number;
    valorSeguro: number;
    valorOutrasDespesas: number;
    ean: string | null;
    origemMercadoria: string | null;
}

export const camposTributariosItem = [
    "tributaIcms", "tributaIpi", "tributaPis", "tributaCofins", "tributaIbs", "tributaCbs",
    "cstIcms", "csosn", "cstIpi", "codigoEnquadramentoIpi", "cstPis", "cstCofins",
    "aliquotaIcms", "aliquotaIpi", "aliquotaPis", "aliquotaCofins", "percentualReducaoBaseIcms", "percentualReducaoBaseIpi",
    "aliquotaIcmsUfDestino", "aliquotaFcpUfDestino", "aliquotaInterestadual", "beneficioFiscal", "percentualDiferimentoIcms",
    "cstIbsCbs", "modalidadeTributacaoIbsCbs", "classificacaoTributaria", "aliquotaIbsEstadual", "aliquotaIbsMunicipal", "aliquotaCbs"
] as const;

export const camposCadastraisEditaveisItem = [
    "tributaIcms", "tributaIpi", "tributaPis", "tributaCofins", "tributaIbs", "tributaCbs", "cstPis", "cstCofins",
    "descricaoProduto", "unidadeComercial", "ncm", "cest", "cfop", "cstIcms", "csosn", "cstIpi",
    "aliquotaIcms", "aliquotaIpi", "aliquotaPis", "aliquotaCofins", "cstIbsCbs", "classificacaoTributaria",
    "aliquotaIbsEstadual", "aliquotaIbsMunicipal", "aliquotaCbs", "origemMercadoria", "codigoEnquadramentoIpi",
    "unidadeTributavel", "quantidadeTributavel", "percentualReducaoBaseIcms", "percentualDiferimentoIcms", "aliquotaIcmsUfDestino",
    "aliquotaFcpUfDestino", "aliquotaInterestadual", "beneficioFiscal", "ean"
] as const;

export type ParametrosFiscaisItemNotaFiscalSaida = Pick<ItemEmissaoNotaFiscalSaida,
    typeof camposTributariosItem[number] | "ncm" | "cest" | "cfop">;

export interface PagamentoEmissaoNotaFiscalSaida {
    tipoIntegracao?: "INTEGRADO" | "NAO_INTEGRADO" | null;
    bandeira?: string | null;
    autorizacao?: string | null;
    cnpjCredenciadora?: string | null;
    formaPagamento: FormaPagamento | null;
    valorPagamento: number;
    descricaoPagamento: string | null;
}

export interface ParcelaEmissaoNotaFiscalSaida {
    numeroParcela: string;
    dataVencimento: string;
    valorParcela: number;
}

export interface VolumeEmissaoNotaFiscalSaida {
    quantidadeVolumes: number;
    especie: string;
    marca: string;
    numeracao: string;
    pesoLiquido: number | null;
    pesoBruto: number | null;
}

export interface EmitirNotaFiscalSaida {
    chaveIdempotencia?: string;
    unidadeOrganizacional: UnidadeOrganizacional | null;
    serieNotaFiscal: SerieNotaFiscal | null;
    transacaoNotaFiscal: TransacaoNotaFiscal | null;
    destinatario: Pessoa | null;
    enderecoDestinatario: PessoaEndereco | null;
    representante: Representante | null;
    condicaoPagamento: CondicaoPagamento | null;
    modelo: "NFE";
    finalidade: string;
    tipoOperacao: "SAIDA";
    destinoOperacao: string | null;
    presencaComprador: string;
    consumidorFinal: string;
    indicadorIntermediador: string | null;
    modalidadeFrete: string;
    dataEmissao?: string | null;
    naturezaOperacao: string;
    informacoesComplementares: string;
    numeroFatura: string | null;
    valorOriginalFatura: number | null;
    valorDescontoFatura: number | null;
    valorLiquidoFatura: number | null;
    itens: ItemEmissaoNotaFiscalSaida[];
    pagamentos: PagamentoEmissaoNotaFiscalSaida[];
    parcelas: ParcelaEmissaoNotaFiscalSaida[];
    volumes: VolumeEmissaoNotaFiscalSaida[];
    notasReferenciadas: { tipoReferencia: "NFE"; chaveAcesso: string }[];
}

export interface OpcoesEmissaoNotaFiscalSaida {
    unidades: UnidadeOrganizacional[];
    series: SerieNotaFiscal[];
    transacoes: TransacaoNotaFiscal[];
    clientes: Pessoa[];
    produtos: Produto[];
    depositos: Deposito[];
    formasPagamento: FormaPagamento[];
    condicoesPagamento: CondicaoPagamento[];
    representantes: Representante[];
}

export interface ResultadoEmissaoNotaFiscalSaida {
    idNotaFiscalSaida: number;
    notaasInvoiceId: string | null;
    status: string;
    mensagem: string;
}

export interface ResultadoConsultaNotaFiscalSaida {
    idNotaFiscalSaida: number;
    status: string;
    numeroNota: number | null;
    chaveAcesso: string | null;
    codigoStatusSefaz: number | null;
    motivoSefaz: string | null;
    estoqueMovimentado: boolean;
    dataUltimaConsulta: string | null;
}
